module.exports = __webpack_public_path__ + "b0a4b15a9200140155ceef0eae23c780.pdf";